import React from "react"
import { Datagrid, EditButton, List, TextField } from "react-admin"

export const MessagesList = (props) => {
    return (
        <List {...props}>
            <Datagrid>
                <TextField source="fullName" />
                <TextField source="email" />
                <TextField source="object" />
                <Buttons />
            </Datagrid>
        </List>
    )
}

const Buttons = (props) => (
    <div {...props}>
        <EditButton {...props} />
    </div>
)
